class ModalContainer extends HTMLElement {
    constructor() {
        super();
        this.lastFocusedElementOutsideModal = undefined;
        this.timeOut = null;
    }

    connectedCallback() {
        this.targetId = this.getAttribute("data-modal-id");

        this.handleModalsOpen = this.handleModalsOpen.bind(this);
        this.handleModalsClose = this.handleModalsClose.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);

        document.addEventListener("modals:open", this.handleModalsOpen);
        document.addEventListener("modals:close", this.handleModalsClose);
        document.addEventListener("keyup", this.handleKeyUp);
    }

    disconnectedCallback() {
        document.removeEventListener("modals:open", this.handleModalsOpen);
        document.removeEventListener("modals:close", this.handleModalsClose);
        document.removeEventListener("keyup", this.handleKeyUp);
    }

    handleModalsOpen(event) {
        const modalId = event.detail.modalId;
        const openButton = event.detail.openButton;

        if (this.targetId === modalId) {
            this.showModal(true);
            this.lastFocusedElementOutsideModal = openButton || undefined;
        }
    }

    handleModalsClose(event) {
        const modalId = event.detail.modalId;

        if (this.targetId === modalId) {
            this.showModal(false);
        }
    }

    handleKeyUp(event) {
        const code = event.code;

        if (code && code.toUpperCase() === 'ESCAPE') {
            this.showModal(false);
        }
    }

    showModal(show) {
        this.shopifySectionWrapper = this.closest(".shopify-section");

        if (!this.shopifySectionWrapper) return;

        this.modalElement = this.shopifySectionWrapper.querySelector(`[data-modal-id=${this.targetId}]`);
        this.closeButton = this.querySelector("[data-modal-close-button]");

        if (show === true) {
            if (!this.modalElement.classList.contains("show")) {
                this.modalElement.classList.add("show");
            }

            new OverflowSwitcher();
            new FocusTrap(this.modalElement);

            setTimeout(() => {
                if (this.closeButton) {
                    this.closeButton.focus();
                }
            }, 300)
        } else {
            this.modalElement.classList.remove("show");

            new OverflowSwitcher();

            if (this.lastFocusedElementOutsideModal) {
                clearTimeout(this.timeOut);
            
                this.timeOut = setTimeout(() => {
                    if (this.lastFocusedElementOutsideModal) {
                        try {
                            this.lastFocusedElementOutsideModal.focus();
                        } catch (err) {
                            console.error("Failed to focus element:", err);
                        } finally {
                            this.lastFocusedElementOutsideModal = undefined;
                        }
                    }
                }, 300);
            }
        }
    }
}

if(!window.customElements.get("modal-container")) {
    window.customElements.define("modal-container", ModalContainer);
}

class ButtonOpenModal extends HTMLElement {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
        this.addEventListener("click", this.handleClick);
    }

    disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
    }

    handleClick(event) {
        if (event.target.closest("[data-modal-open-button]")) {
            const target = event.target.closest("[data-modal-open-button]");
            const targetModalId = target.getAttribute("data-modal-open-button");
            
            document.dispatchEvent(new CustomEvent("modals:open", {
                detail: {
                    modalId: targetModalId,
                    openButton: target,
                }
            }))
        }
    }
}
  
if (!window.customElements.get("button-open-modal")) {
    customElements.define("button-open-modal", ButtonOpenModal)
}

class ButtonCloseModal extends HTMLElement {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
        this.addEventListener("click", this.handleClick);
    }

    disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
    }

    handleClick(event) {
        if (event.target.closest("[data-modal-close-button]")) {
            const target = event.target.closest("[data-modal-close-button]");
            const targetModalId = target.getAttribute("data-modal-close-button");

            document.dispatchEvent(new CustomEvent("modals:close", {
                detail: {
                    modalId: targetModalId
                }
            }))
        }
    }
}

if (!window.customElements.get("button-close-modal")) {
    customElements.define("button-close-modal", ButtonCloseModal)
}

class ModalBackdrop extends HTMLElement {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
        this.addEventListener("click", this.handleClick)
    }

    disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
    }

    handleClick(event) {
        if (event.target.closest("[data-modal-backdrop]:not(.is-parent)")) {
            const target = event.target.closest("[data-modal-backdrop]");
            const targetModalId = target.getAttribute("data-modal-backdrop");

            document.dispatchEvent(new CustomEvent("modals:close", {
                detail: {
                    modalId: targetModalId
                }
            }))
        }
    }
}

if (!window.customElements.get("modal-backdrop")) {
    customElements.define("modal-backdrop", ModalBackdrop)
}